import type { RouteRecordRaw } from 'vue-router';

import DefaultBarView from '@views/Navigation/DefaultBarView.vue';
import DefaultRailView from '@views/Navigation/DefaultRailView.vue';

import ContactDetail from '@views/Contact/ContactDetail.vue';
import ContactEdit from '@views/Contact/Detail/Modals/ContactEdit.vue';
import DuplicateLead from '@views/Contact/Detail/Modals/DuplicateLead.vue';

import generateLeadRoutes from '@router/lead';
import generateOrderRoutes from '@router/order';
import WrapperView from '@views/WrapperView.vue';
import CreateOrder from '@views/Contact/Detail/Modals/CreateOrder.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/contact',
        name: 'contact',
        redirect: { name: 'contactList' },
        components: {
            default: WrapperView,
            bar: DefaultBarView,
            rail: DefaultRailView,
        },
        children: [
            {
                path: '',
                name: 'contactList',
                redirect: { name: 'root' },
            },
            {
                path: ':contactId',
                name: 'contactDetail',
                props: {
                    default: (route) => ({
                        contactId: route.params.contactId,
                    }),
                },
                components: {
                    default: ContactDetail,
                    bar: DefaultBarView,
                    rail: DefaultRailView,
                },
                children: [
                    {
                        path: 'contact-edit',
                        name: 'contactEdit',
                        props: {
                            default: (route) => ({
                                contactId: route.params.contactId,
                            }),
                        },
                        components: {
                            default: ContactEdit,
                        },
                    },
                    {
                        path: 'duplicate/:pipelineId',
                        name: 'duplicateLead',
                        props: {
                            default: (route) => ({
                                pipelineId: route.params.pipelineId,
                                contactId: route.params.contactId,
                            }),
                        },
                        components: {
                            default: DuplicateLead,
                        },
                    },
                    {
                        path: 'create-order/:leadId',
                        name: 'createOrder',
                        props: {
                            default: (route) => ({
                                leadId: route.params.leadId,
                                contactId: route.params.contactId,
                            }),
                        },
                        components: {
                            default: CreateOrder,
                        },
                    },

                    ...generateLeadRoutes('contact'),
                    ...generateOrderRoutes('contact'),
                ],
            },
        ],
    },
];

export default routes;
